export enum CognitoErrorCode {
  NotAuthorizedException = 'NotAuthorizedException',
}
